export type MistakeAiMode = 'simple_explain' | 'source_grounded' | 'followup_questions' | 'compare_paths' | 'retry_coach';

export type MistakeAiRequest = {
  mode: MistakeAiMode;
  slug: string;
  user_id: string;
  attempt_id: string;
};

export type MistakeAiResponse = {
  ok: boolean;
  mode: MistakeAiMode;
  grounded: boolean;
  content: {
    title: string;
    bullets: string[];
    follow_up_questions?: string[];
    next_step?: string;
    confidence_note?: string;
  };
  fallback?: boolean;
};

const SUPABASE_URL = process.env.EXPO_PUBLIC_SUPABASE_URL ?? '';
const SUPABASE_ANON_KEY = process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY ?? '';

export async function requestMistakeAiHelp(input: MistakeAiRequest): Promise<MistakeAiResponse> {
  const res = await fetch(`${SUPABASE_URL}/functions/v1/kp-mistake-ai-help`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify(input),
  });

  const data = await res.json().catch(() => null);
  if (!res.ok || !data) {
    throw new Error(data?.error ?? 'AI help unavailable');
  }

  return data as MistakeAiResponse;
}
